import { Component } from 'react';

import PropTypes from 'prop-types';

import { LocationContext } from 'common/containers/RouterContainer';
import { ViewerContext } from 'common/containers/ViewerContainer';
import cloneElementWithProps from 'common/core/cloneElementWithProps';
import isUserProbablyInTargetCountry from 'common/util/isUserProbablyInTargetCountry';
import loadScript from 'common/util/loadScript';
import withContexts from 'common/util/withContexts';

const PercentOfUsersToTrack = 50;
const ScriptID = 'lucky-orange-sdk';
const ScriptURL = 'https://tools.luckyorange.com/core/lo.js?site-id=2d4e3131';

class LuckyOrangeContainer extends Component {
  static propTypes = {
    viewer: PropTypes.shape({
      _id: PropTypes.string,
      companies: PropTypes.array,
      created: PropTypes.string,
      email: PropTypes.string,
      name: PropTypes.string,
    }),
  };

  componentDidMount() {
    if (__DEV__) {
      return;
    }

    if (!isUserProbablyInTargetCountry()) {
      return;
    }

    const randomPercent = 100 * Math.random();
    if (randomPercent < PercentOfUsersToTrack) {
      return;
    }

    const {
      location: { pathname },
    } = this.props;

    if (/\/asana-redirect/.test(pathname)) {
      // Don't run LuckyOrange on the Asana Redirect page.
      return;
    }

    // only record on pages with LuckyOrangeContainer
    window.LOQ = window.LOQ || [];
    loadScript(ScriptURL, ScriptID);

    window.LOQ.push([
      'ready',
      async (LO) => {
        await LO.$internal.ready('visitor');

        const { viewer } = this.props;
        const viewerExistsAndHasCompanies =
          viewer && viewer.email && viewer.companies && viewer.companies.length > 0;
        if (!viewerExistsAndHasCompanies) {
          return;
        }

        const hasQCompany = viewer.companies.some((company) => {
          return company.q.q;
        });
        const hasVCompany = viewer.companies.some((company) => {
          return company.q.v;
        });

        LO.visitor.identify(viewer._id, {
          email: viewer.email,
          hasQCompany,
          hasVCompany,
          name: viewer.name,
        });
      },
    ]);
  }

  render() {
    return cloneElementWithProps(this.props.children, this.props);
  }
}

export default withContexts({
  location: LocationContext,
  viewer: ViewerContext,
})(LuckyOrangeContainer);
